import { BoxModel, IBlockProps, VIDEO_BLOCK_TYPE } from '@fox/blocks';
import { getAttributeValues, transformLegacyProps } from '../../../utils';
type VideoProps = {
	videoUrl?: string;
	attributes?: {
		padding?: BoxModel;
	};
};
export const VideoBlock = ({ props, type }: IBlockProps<VideoProps>) => {
	const { attributes, videoUrl } = transformLegacyProps(type, props) as VideoProps;
	const padding = attributes?.padding;
	const { top: paddingTop, bottom: paddingBottom, right: paddingRight, left: paddingLeft } = getAttributeValues(padding);

	const getThumb = (url: string) => {
		if (url === null) {
			return '';
		}
		const results = url.match(
			/(?:https?:\/\/)?(?:youtu\.be\/|(?:www\.|m\.)?youtube\.com\/(?:watch|v|embed)(?:\.php)?(?:\?.*v=|\/))([a-zA-Z0-9\_-]+)/
		);
		const video = results === null ? url : results[1];

		return 'http://img.youtube.com/vi/' + video + '/0.jpg';
	};

	const imageUrl = getThumb(videoUrl || '');

	return (
		<>
			{imageUrl ? (
				<div style={{ paddingTop, paddingBottom, paddingLeft, paddingRight }}>
					<a target="_blank" href={videoUrl}>
						<img style={{ width: '100%' }} src={imageUrl} />
					</a>
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export const VideoBlockRuntime = {
	type: VIDEO_BLOCK_TYPE,
	Component: VideoBlock
};
